import validate from "/home/ploi/nmodata.nl/front-end/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/ploi/nmodata.nl/front-end/middleware/auth.global.ts";
import set_45theme_45global from "/home/ploi/nmodata.nl/front-end/middleware/set-theme.global.ts";
import manifest_45route_45rule from "/home/ploi/nmodata.nl/front-end/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  set_45theme_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}